import { SpotlightKey } from '@reach/interfaces/spotlights/spotlights.enum';

import { VALID_ONBOARDING_KEYS } from '../constants/public_api';

export const isValidOnboardingKey = (key: unknown): key is SpotlightKey => {
	return VALID_ONBOARDING_KEYS.includes(key as SpotlightKey);
};
